import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable, Postable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiSample {

  // GET parameters
  export namespace Get {

    export interface Request {
      query: {
        paramA: number,
        paramB: number
      }
    }

    // API Response
    export interface Response {
      parameterA: number,
      parameterB: number
    }
  }

  // POST parameters
  export namespace Post {
    export interface Request {
      body: {
        parameterA: number,
        parameterB: number
      }
    }

    // API Response
    export interface Response {
      parameterA: number,
      parameterB: number
    }
  }

  // API Path
  const path: string = '/xxx/sample'

  // API本体
  export class Api extends ApiBase
    implements Gettable<Get.Request, Get.Response, ResponseError>, Postable<Post.Request, Post.Response, ResponseError> {

    // GET
    public get<R>(params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>)
      : Promise<R | null> {

      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        parameterA: 0,
        parameterB: 0
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: ''
        }
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample)
    }

    // POST
    public post<R>(params: Post.Request,
      successHandler: ApiResponseHandler<Post.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>)
      : Promise<R | null> {

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: ''
        }
      }

      // API呼び出し
      return this.callbackWrapper<Post.Response, ResponseError, R>(
        api.post<Post.Response>(path, params.body),
        successHandler,
        errorHandler,
        undefined,
        validationErrorSample)
    }
  }
}